import React from 'react';
import Datefy from '../../../utils/Date';

const Experience = ({ formData, setFormData }) => {
  const { experience } = formData;
  const { setDate, getDate } = Datefy;
  const onChangeExperience = (e, i) => {
    const tempArr = [...experience];
    tempArr[i][e.target.name] =
      e.target.type === 'checkbox'
        ? e.target.checked
        : e.target.type === 'date'
        ? getDate(e.target.value)
        : e.target.value;
    setFormData({
      ...formData,
      experience: tempArr,
    });
  };
  return (
    <div>
      <h3>
        Experience
        <small>
          <a
            href='#!'
            style={{ float: 'right' }}
            className='btn btn-sm btn-primary'
            onClick={(e) => {
              e.preventDefault();
              const tempArr = [
                ...experience,
                {
                  from: '',
                  current: '',
                  to: '',
                  jobTitle: '',
                  employer: '',
                  description: '',
                  location: '',
                },
              ];
              setFormData({
                ...formData,
                experience: tempArr,
              });
            }}
          >
            Add experience
          </a>
        </small>
      </h3>
      {experience.map((each, index, arr) => (
        <div className='card card-body my-3' key={index}>
          <div className='row'>
            <div className='col-md-4 col-sx-12 '>
              <div className='form-group'>
                <label htmlFor={`experience[${index}].employer`}>
                  Name of employer/organization{' '}
                </label>
                <input
                  type='text'
                  value={each.employer}
                  onChange={(e) => onChangeExperience(e, index)}
                  id={`experience[${index}].employer`}
                  name='employer'
                  className='form-control'
                />
              </div>
              <div className='form-group'>
                <label htmlFor={`experience[${index}].jobTitle`}>
                  Job title{' '}
                </label>
                <input
                  type='text'
                  value={each.jobTitle}
                  onChange={(e) => onChangeExperience(e, index)}
                  id={`experience[${index}].jobTitle`}
                  name='jobTitle'
                  className='form-control'
                />
              </div>
              <div className='form-group'>
                <label htmlFor={`experience[${index}].location`}>
                  Location{' '}
                </label>
                <input
                  type='text'
                  value={each.location}
                  onChange={(e) => onChangeExperience(e, index)}
                  id={`experience[${index}].location`}
                  name='location'
                  className='form-control'
                />
              </div>
            </div>
            <div className='col-md-4 col-sx-12 form-group'>
              <label htmlFor={`experience[${index}].description`}>
                Description{' '}
              </label>
              <textarea
                type='text'
                rows='8'
                value={each.description}
                onChange={(e) => onChangeExperience(e, index)}
                id={`experience[${index}].description`}
                name='description'
                className='form-control'
              />
            </div>
            <div className='col-md-4 col-sx-12'>
              <div className='form-group'>
                <label htmlFor={`experience[${index}].from`}>From </label>
                <input
                  type='date'
                  value={setDate(each.from)}
                  onChange={(e) => onChangeExperience(e, index)}
                  id={`experience[${index}].from`}
                  max={setDate(new Date())}
                  name='from'
                  className='form-control'
                />
              </div>
              <div className='form-check'>
                <input
                  type='checkbox'
                  value={each.current}
                  onChange={(e) => {
                    onChangeExperience(e, index);
                  }}
                  id={`experience[${index}].current`}
                  name='current'
                  className='form-check-input'
                />
                <label htmlFor={`experience[${index}].current`}>
                  Are you currently there?{' '}
                </label>
              </div>
              <div className='form-group'>
                <label htmlFor={`experience[${index}].to`}>To </label>
                <input
                  type='date'
                  value={setDate(each.to)}
                  onChange={(e) => onChangeExperience(e, index)}
                  id={`experience[${index}].to`}
                  max={setDate(new Date())}
                  name='to'
                  min={setDate(arr[index].from)}
                  disabled={arr[index].current}
                  className='form-control'
                />
              </div>
            </div>
          </div>
          <small style={{ marginTop: -10, display: 'block' }}>
            <a
              href='#!'
              onClick={(e) => {
                e.preventDefault();
                const tempArr = [...experience];
                tempArr.splice(index, 1);
                setFormData({
                  ...formData,
                  experience: tempArr,
                });
              }}
            >
              Delete
            </a>
          </small>
        </div>
      ))}
    </div>
  );
};

export default Experience;
